<template>
<div style="margin-bottom:3rem">

  <!-- DIALO  WITH OPTIONS  -->
  <v-dialog width="1000" v-model="show">
    <v-btn color="primary" slot="activator">
      {{ $t('related.new_data_type') }}
    </v-btn>
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('related.new_data_type') }}
      </v-card-title>
      <v-container>
        <v-form ref="form" v-model="valid" v-on:submit="save">
          <v-flex xs8>
            <v-text-field v-model="name" :rules="nameRules" :label="`${$t('related.name')}`" required></v-text-field>
          </v-flex>
          <div>
            <h3> {{ $t('related.schema_keys') }} : </h3>
            <div :key="index" v-for="(keyName, index) in keysSchemaName">
              <v-layout>
                <v-flex xs5 sm3>
                  <v-text-field :rules="keyRules" style="margin-left:2rem;" v-model="keysSchemaName[index]" :label="`${$t('related.key')}`" required></v-text-field>
                </v-flex>
                <v-flex xs2 sm1>
                  <v-btn v-if="index!=0" style="margin-left:2rem;" fab small block @click="keysSchemaName.splice(index,1)">
                    <v-icon small>remove</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex v-if="index>=keysSchemaName.length-1" xs2 sm2>
                  <v-btn fab small @click="keysSchemaName.push('')">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>

          <v-btn type="submit">
            {{ $t('archive.filter.save') }}
          </v-btn>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
  <!-- END DIALOG -->

</div>
</template>
<script>
import http from '@/plugins/http'

export default {
  components: {},
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      name: "",
      valid: false,
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => !!v && (v.length <= 100 && v.length > 1) || this.$t('validator.wrong_length'),
      ],
      keyRules: [
        v => !!v || this.$t('validator.blank'),
        v => !!v && (v.length <= 100 && v.length > 1) || this.$t('validator.wrong_length'),
      ],
      keysSchemaName: [""],
      show: false
    }
  },
  methods: {
    save(e) {
      e.preventDefault();
      if (this.valid) {
        http.post('related/schema ', this.getPayload())
          .then((data) => {
            this.$emit("created", data.data)
            this.$refs.form.reset()
            this.show = false;
            this.showMessage(this.$t('related.created'), "success")
          })
          .catch((e) => this.showMessage(this.$t('related.cannot_create'), "danger"))
      }
    },
    getPayload() {
      let payload = {}
      payload.name = this.name
      payload.keys = this.keysSchemaName
        .map((key, index) => ({
          "order": index + 1,
          "name": key
        }))

      return payload;
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}
</style>
